import type {
  DeclaredComplementRelationship,
  GetCompletedComplementsResponse,
  PostComplementInviteResponse,
  ComplementInviteContext,
} from '../../types/complementInvite';
import fetcher from '../../utils/fetcher';

export async function getCompletedComplements(token: string):
Promise<GetCompletedComplementsResponse> {
  const response = await fetcher(
    `${process.env.REACT_APP_API_URL}/complement-invite/completed`,
    'GET',
    null,
    token,
  );
  return response;
}

export async function postComplementInvite(params: {
  token: string,
  declaredRelationship: DeclaredComplementRelationship,
}): Promise<PostComplementInviteResponse> {
  const { token, declaredRelationship } = params;
  const response = await fetcher(
    `${process.env.REACT_APP_API_URL}/complement-invite`,
    'POST',
    { declaredRelationship },
    token,
  );
  return response;
}

export async function getComplementInviteContext(inviteToken: string):
Promise<ComplementInviteContext> {
  const res = await fetch(
    `${process.env.REACT_APP_API_URL}/complement-invite/${inviteToken}`,
    { method: 'GET' },
  );
  if (res.status === 429) {
    // eslint-disable-next-line no-throw-literal
    throw 429;
  }
  const contentType = res.headers.get('content-type') || '';
  if (!contentType.includes('application/json')) {
    // eslint-disable-next-line no-throw-literal
    throw res.status;
  }
  const response = await res.json();
  if (res.ok) {
    return { ...response, status: res.status };
  }
  // eslint-disable-next-line no-throw-literal
  throw res.status;
}
